import { BannerGroupLayout } from "../../components/banner-group/BannerGroupLayout";

const test = ({ layout }: { layout: string }): boolean =>
  layout === "Banner Group";

const create = (props): JSX.Element => {
  return <BannerGroupLayout {...props} />;
};

export default { test, create };
